module.exports = __webpack_public_path__ + "img/woocom.c97e165d.png";